const acceptAndClose: { [key: string]: string } = {
  en: 'accept & close',
  de: 'akzeptieren & schließen',
  'de-AT': 'akzeptieren & schließen',
  'de-CH': 'akzeptieren & schliessen',
  fr: 'accepter et fermer',
  'fr-CH': 'accepter et fermer',
  nl: 'accepteren & sluiten',
};

const allTranslations = {
  acceptAndClose,
};

export const i18n = (key: keyof typeof allTranslations, locale: string): string => {
  const translations = allTranslations[key];

  return translations[locale] || translations['en'];
};
